export default __webpack_public_path__ + "static/part3-screenshot-ca00547f7e89f9289e97779c6ad3b71b.png";